import { del, get, post, put } from './request'

interface OtherAcceptedPayments {
    supplier: string;
    propertyId: string;
    property: {
        otherpayments: {
            otheracceptedpayments: Array<object>
        }
    };
}

interface OtherCardTypes {
    supplier: string;
    propertyId: string;
    property: {
        otherpayments: {
            othercardtypes: Array<object>
        }
    };
}

interface OtherFeeTax {
    supplier: string;
    propertyId: string;
    property: {
        otherpayments: {
            otherfeetax: Array<object>
        }
    };
}

export const getOtherpayments = (supplier: string, propertyid: string) => get(`/property/otherpayments?supplier=${supplier}&propertyid=${propertyid}`)
export const addOtherAcceptedPayments = (otheracceptedpayments: OtherAcceptedPayments) => post('/property/otherpayments/otheraccepted', otheracceptedpayments)
export const updateOtherAcceptedPayments = (otheracceptedpayments: OtherAcceptedPayments) => put('/property/otherpayments/otheraccepted', otheracceptedpayments)
export const deleteOtherAcceptedPayments = (otheracceptedpayments: OtherAcceptedPayments) => del('/property/otherpayments/otheraccepted', otheracceptedpayments)

export const addOtherCardTypes = (othercardtypes: OtherCardTypes) => post('/property/otherpayments/othercards', othercardtypes)
export const updateOtherCardTypes = (othercardtypes: OtherCardTypes) => put('/property/otherpayments/othercards', othercardtypes)
export const deleteOtherCardTypes = (othercardtypes: OtherCardTypes) => del('/property/otherpayments/othercards', othercardtypes)

export const addOtherFeeTax = (otherfeetax: OtherFeeTax) => post('/property/otherpayments/otherfeetax', otherfeetax)
export const updateOtherFeeTax = (otherfeetax: OtherFeeTax) => put('/property/otherpayments/otherfeetax', otherfeetax)
export const deleteOtherFeeTax = (otherfeetax: OtherFeeTax) => del('/property/otherpayments/otherfeetax', otherfeetax)